export default "__VITE_ASSET__K6E53aos__"